<template>
  <!-- стрелка вправо для ссылок «Смотреть все»; цвет — currentColor -->
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path d="M5 12h14M13 6l6 6-6 6" />
  </svg>
</template>

<script>
export default {
  name: "ArrowIcon",
};
</script>
